import moment from 'moment-timezone';

// Set the default time zone to Asia/Kolkata
moment.tz.setDefault('Asia/Kolkata');

export default moment;
